import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const postNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const postCareerApplication = (payload) =>
  api.post("/careers/apply", payload).then((r) => r.data);
export const getOpenings = () => api.get("/careers/openings").then((r) => r.data.openings);
export const postInvestmentInquiry = (payload) =>
  api.post("/investments/inquire", payload).then((r) => r.data);
